import detalhes from './detalhes'

export default {
  namespaced: true,
  modules: {
    details: detalhes
  }
}
